import * as React from "react"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../components/layout"
import Seo from "../components/seo"

import GlobalHero from "../components/jsx-components/global-hero"

import yourBlueprintLogo from "../images/your-blueprint-logo.png"
import iconLink from "../images/icon-link.png"

import CTAEnroll from "../components/jsx-components/cta-enroll"
import ConditionButton from "../components/jsx-components/condition-button"
import Cta from "../components/tsx-components/cta"
import { ExternalLinkYellow } from "../components/tsx-components/icons"
import BlueprintBlock from "../components/jsx-components/blueprint-block"

const Index = () => (
  <Layout site="gateway">
    <div id="gateway-container">
      <GlobalHero
        type="gateway"
        headline={<>AYVAKIT is approved<br/> for the treatment<br/> of 3 indications</>}
        subhead=""
      />

      <div className="inner-container">
        <div className="row card-blueprint-row">
          <BlueprintBlock />
        </div>
      </div>
    </div>
  </Layout>
)

export const Head = () => (
  <Seo
    title="Treatment for ISM, AdvSM, & PDGFRA GIST | AYVAKIT® (avapritinib)"
    description="Learn about AYVAKIT®, an oral therapy for ISM, AdvSM, and PDGFRA GIST. See ISI and PI for more info."
  />
)

export default Index
